import { DropdownMenu } from '@dittolive/anvil'
import graphql from 'babel-plugin-relay/macro'
import { useEffect } from 'react'
import { useLazyLoadQuery, useRefetchableFragment } from 'react-relay/hooks'

import { OrganizationsMenuItem_viewer$key } from './__generated__/OrganizationsMenuItem_viewer.graphql'
import { OrganizationsMenuItemQuery } from './__generated__/OrganizationsMenuItemQuery.graphql'
import { OrganizationsRefetchQuery } from './__generated__/OrganizationsRefetchQuery.graphql'

const query = graphql`
  query OrganizationsMenuItemQuery {
    viewer {
      ...OrganizationsMenuItem_viewer
    }
  }
`

const refetchableOrganizations = graphql`
  fragment OrganizationsMenuItem_viewer on Viewer
  @refetchable(queryName: "OrganizationsRefetchQuery") {
    me {
      id
      organizations {
        id
        name
        slug
      }
    }
  }
`

type Props = {
  /** True if the menu item is open */
  isOpen: boolean
  /** Callback for when the tenant is changed */
  onChangeTenant: (tenant: string | null) => void
}

export default function OrganizationsMenuItems({
  isOpen,
  onChangeTenant,
}: Props) {
  const { viewer } = useLazyLoadQuery<OrganizationsMenuItemQuery>(query, {})
  const [data, refetch] = useRefetchableFragment<
    OrganizationsRefetchQuery,
    OrganizationsMenuItem_viewer$key
  >(refetchableOrganizations, viewer)

  useEffect(() => {
    if (isOpen) {
      refetch({}, { fetchPolicy: 'store-and-network' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <>
      <DropdownMenu.Item onSelect={() => onChangeTenant(null)}>
        Personal
      </DropdownMenu.Item>

      {data?.me?.organizations?.map((org) => (
        <DropdownMenu.Item
          key={org?.id}
          onSelect={() => onChangeTenant(org?.slug ?? null)}
        >
          {org?.name}
        </DropdownMenu.Item>
      ))}
    </>
  )
}
